import { Component, Input, OnInit, inject, input } from '@angular/core';

import { Author } from '../../../shared/interfaces/research-portal/full-asset-page/asset-model/asset-model-relations/author.interface';
import { I18nService } from '../../../core/i18n.service';
import { ConfigurationHandlerService } from '../../../core/configuration-handler.service';
import { FullAssetPage } from '../../../shared/configurations/full-asset-page.constant';
import { UrlUtils } from '../../../shared/utils/url.utils';
import { FullAssetPageCreatorsConfiguration } from '../../../shared/interfaces/research-portal/portal-configuration/full-asset-page-creators-configuration.interface';
import { Discovery } from '../../../shared/configurations/discovery.constant';
import { TranslateModule } from '@ngx-translate/core';
import { RouterLink } from '@angular/router';
import { MatIcon } from '@angular/material/icon';
import { HideOnPrintDirective } from '@exl-ng/mulo-core';
import { MatButton } from '@angular/material/button';
import { NgIf, NgFor, NgTemplateOutlet, SlicePipe } from '@angular/common';

@Component({
    selector: 'esp-authors-essentials',
    templateUrl: './authors-essentials.component.html',
    styleUrls: ['./authors-essentials.component.scss'],
    imports: [
        NgIf,
        NgFor,
        NgTemplateOutlet,
        MatButton,
        HideOnPrintDirective,
        MatIcon,
        RouterLink,
        SlicePipe,
        TranslateModule,
    ],
})
export class AuthorsEssentialsComponent implements OnInit {
    private configSvc = inject(ConfigurationHandlerService);
    private i18nService = inject(I18nService);

    // TODO: Skipped for migration because:
    //  This input is used in a control flow expression (e.g. `@if` or `*ngIf`)
    //  and migrating would break narrowing currently.
    @Input() creators: Author[];
    readonly creatorsConfig =
        input<FullAssetPageCreatorsConfiguration>(undefined);
    readonly showUserDetails = input<boolean>(undefined);

    maxVisibleAuthors = FullAssetPage.MAX_ESSENTIALS_AUTHORS;
    authorsDetails = false;
    portalNewSearchResults: boolean;
    isProfileActivate: boolean;

    institutionCode = UrlUtils.getParam('institution');

    ngOnInit(): void {
        this.portalNewSearchResults =
            this.configSvc.getCustomerParameter(
                'esploro_new_search_results_page',
            ) === 'true';
        this.isProfileActivate = this.configSvc.isProfileActivate();
    }

    getAuthorSearchLinkInDiscovery(author: Author) {
        let baseUrl = this.configSvc.externalFacingBaseUrl();
        let url = baseUrl + FullAssetPage.AUTHOR_SEARCH_IN_DISCOVERY;
        url = url.replace('{{inst}}', this.institutionCode);
        url = url.replace('{{display_name}}', author.nameForSearch);
        url = url.replace('{{lang}}', this.i18nService.getLanguage());
        return url;
    }

    toggleAuthorsDetails() {
        this.authorsDetails = !this.authorsDetails;
    }

    getCreatorSearchQueryParams(author: Author) {
        return {
            query:
                Discovery.CREATORS_ADVANCED_SEARCH_QUERY_PREFIX +
                author.nameForSearch +
                ',AND',
            page: 1,
            sort: 'date_d',
            mode: 'advanced',
            institution: this.institutionCode,
        };
    }
}
